import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cfg from '../../config/config.default';
import './Slide.css';

export default class Slide extends Component {
  static propTypes = {
    design: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.imageTimeout = null;
    this.state = {
      currentImageIndex: 0,
      rdmCountryCode: 'de',
    };
  }

  /**
   * Format a UNIX date string
   *
   * @param {string} date
   * @returns {string}
   */
  formatDate(date) {
    const _date = new Date(date);
    const d = _date.toLocaleDateString();
    const t = _date.toLocaleTimeString().split(':');

    return `${ t[0] }:${ t[1] }, ${ d }`;
  }

  /**
   * Transform mm into cm and round the result
   *
   * @param {number} mm
   * @returns {number}
   */
  mmToCm(mm) {
    return Math.round(mm / 10);
  }

  /**
   * Rotate between images
   */
  setImageInterval() {
    clearTimeout(this.imageTimeout);

    let count = 0;

    // Preload images
    const { design } = this.props;
    design.images.forEach(url => new Image(url));

    const changeImage = () => {
      this.setState({ currentImageIndex: count });
      count += 1;
      this.imageTimeout = setTimeout(changeImage, 3000);
    };

    changeImage();
  }

  setRdmCountryCode() {
    const countryCodes = Object.keys(cfg.countries.codesToNames);
    const rdmCountryCode = countryCodes[Math.floor(Math.random() * countryCodes.length - 1)];

    this.setState({ rdmCountryCode });
  }

  /**
   * Renderd the details of the design
   *
   * @param {object} design
   * @return {React.JSX}
   * @memberof Slide
   */
  renderDetails(design){
    const { rdmCountryCode } = this.state;
    const price = design.price[rdmCountryCode] || design.price['de'];
    const totalPriceInclTaxes = price.totalPriceInclTaxes;
    const priceCode = rdmCountryCode === 'ch' ? 'CHF' : '€'

    return (
      <div>
        <div className="price">
          <span>{ cfg.countries.codesToNames[rdmCountryCode] }</span>
          <span>{ totalPriceInclTaxes } { priceCode }</span>
        </div>

        { cfg.showShipping && (
          <div className="shipping">
            <div>Bought on { this.formatDate(design.updated_at) }</div>
            <div>Shipping ({ rdmCountryCode }): { price.shippingDuration } days</div>
          </div>
        ) }
      </div>
    )
  }

  componentWillMount() {
    this.setRdmCountryCode();
    this.setImageInterval();
  }

  componentWillReceiveProps() {
    this.setRdmCountryCode();
    this.setImageInterval();
  }

  componentWillUnmount() {
    clearTimeout(this.imageTimeout);
  }

  /**
   * @return {React.JSX}
   */
  render() {
    const { design } = this.props;
    const { currentImageIndex } = this.state;

    let images = design.images.filter(img => img.quality === 'hires');
    if (images.length === 0) images = design.images;
    const currentImage = images[currentImageIndex % images.length];
    const imgCSS = { backgroundImage: `url(https:${ currentImage ? currentImage.url : '' })` };

    return (
      <div className="Slide">
        <div className="pic" style={ imgCSS } />
        <h5 className="ribbon">Sold</h5>

        <div className="metadata" >
          <div className="title">
            { cfg.furnitureTypes[design.furniture_type] || design.furniture_type }
          </div>
          <div className="subtitle">
            { cfg.furnitureNames[design.furniture_type] || design.furniture_type }
          </div>
          <div className="uuid">
            <em>(UUID: { design.uuid })</em>
          </div>

          { this.renderDetails(design) }

          <div className="dimensions">
            <h5>Measurements:</h5>
            <div className="row">
              <span>Height:</span>
              <span>{ this.mmToCm(design.dimensions.height) } cm</span>
            </div>
            <div className="row">
              <span>Width:</span>
              <span>{ this.mmToCm(design.dimensions.width) } cm</span>
            </div>
            <div className="row">
              <span>Length:</span>
              <span>{ this.mmToCm(design.dimensions.length) } cm</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Slide/Slide.js